import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=55de9a03&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=55de9a03&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55de9a03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55de9a03')) {
      api.createRecord('55de9a03', component.options)
    } else {
      api.reload('55de9a03', component.options)
    }
    module.hot.accept("./CustomSelect.vue?vue&type=template&id=55de9a03&scoped=true", function () {
      api.rerender('55de9a03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Importer/components/CustomSelect.vue"
export default component.exports